import {firebaseAction} from 'vuexfire'
import firebase from 'firebase/app'
import axios from 'axios';
import i18n from '@/config/i18n';

export default {
    namespaced: true,
    state: {
        list: [],

    },
    getters: {},

    actions: {
        setList: firebaseAction(({bindFirebaseRef}, ref) => {
            return new Promise(resolve => {
                bindFirebaseRef('list', ref, {
                    readyCallback() {
                        resolve();
                    }
                })
            })
        }),
        createUser: function (context, form) {
            return new Promise((resolve) => {

                let payload = form.user;
                let id = firebase.database().ref().push().key;

                firebase.database().ref('users').child(id).set(payload).then(() => {
                    resolve(id)
                });
            })
        },
        updateUser: function (context, data) {
            data = data.data;//???
            return new Promise(resolve => {
                firebase.database().ref('users/' + data.id).update({
                    email: data.email,
                    pass: data.pass
                }).then(() => resolve());
            });
        },
        deleteUser: function ( context, { id}) {
            return firebase.database().ref('/users').child(id).remove();
        },
    }
}
